import React from 'react';
import { ColumnSelect } from 'lib/components/ColumnSelect';
import { Product } from 'lib/enums';
import { PublishingMedium } from 'lib/enums/PublishingMedium';
import { PublicationIssueStatus } from 'lib/types/publicationIssue';

export type PublicationIssuesTableFilter = {
  status: string;
  medium: string;
  product: string;
};

const STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: PublicationIssueStatus.APPROVED, label: 'Approved' },
  {
    value: PublicationIssueStatus.AWAITING_APPROVAL,
    label: 'Awaiting approval'
  },
  {
    value: PublicationIssueStatus.READY_FOR_PAGINATION,
    label: 'Ready for pagination'
  },
  {
    value: PublicationIssueStatus.CHANGES_REQUESTED,
    label: 'Changes requested'
  },
  {
    value: PublicationIssueStatus.ARCHIVED,
    label: 'Archived'
  }
];

const MEDIUM_OPTIONS = [
  { value: '', label: 'All mediums' },
  { value: PublishingMedium.Print, label: 'Print' },
  { value: PublishingMedium.Online, label: 'Online' },
  { value: PublishingMedium.EEdition, label: 'E-edition' }
];

const PRODUCT_OPTIONS = [
  { value: '', label: 'All products' },
  { value: Product.Notice, label: 'Notice' },
  { value: Product.Obituary, label: 'Obituary' },
  { value: Product.Classified, label: 'Classified' }
];

function PublicationIssuesTableFilterDialog({
  filter,
  setFilter
}: {
  filter: PublicationIssuesTableFilter;
  setFilter: (f: PublicationIssuesTableFilter) => void;
}) {
  return (
    <div className="flex flex-col gap-3">
      <ColumnSelect
        id="pagination-status-select"
        labelText="Status"
        options={STATUS_OPTIONS}
        value={filter.status}
        onChange={value => setFilter({ ...filter, status: value })}
        size="sm"
      />
      <ColumnSelect
        id="pagination-medium-select"
        labelText="Medium"
        options={MEDIUM_OPTIONS}
        value={filter.medium}
        onChange={value => setFilter({ ...filter, medium: value })}
        size="sm"
      />
      <ColumnSelect
        id="pagination-product-select"
        labelText="Product"
        options={PRODUCT_OPTIONS}
        value={filter.product}
        onChange={value => setFilter({ ...filter, product: value })}
        size="sm"
      />
    </div>
  );
}

export default PublicationIssuesTableFilterDialog;
